import React from 'react';
import { MapPinIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
import { getCountryName } from '../utils/countryUtils';
export function AddressList({
  addresses,
  onEdit,
  onDelete,
  locale
}) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-14324">
      {addresses.map(address => <div key={address.id} className={`relative rounded-lg border ${address.isPrimary ? 'border-indigo-500' : 'border-gray-300'} bg-white px-6 py-5 shadow-sm flex flex-col space-y-2 hover:border-indigo-400`} data-id="element-14325">
          {address.isPrimary && <span className="absolute top-0 right-0 -mt-2 -mr-2 px-2 py-1 text-xs font-bold rounded-full bg-indigo-100 text-indigo-800 flex items-center" data-id="element-14326">
              <CheckIcon className="h-3 w-3 mr-1" data-id="element-14327" />
              Primary
            </span>}
          <div className="flex items-center space-x-3" data-id="element-14328">
            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-14329">
              <MapPinIcon className="h-6 w-6 text-gray-500" data-id="element-14330" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-14331">
              <p className="text-sm font-medium text-gray-900 truncate" data-id="element-14332">
                {address.addressType}
              </p>
            </div>
          </div>
          <div className="text-sm text-gray-500" data-id="element-14333">
            <p data-id="element-14334">{address.line1}</p>
            {address.line2 && <p data-id="element-14335">{address.line2}</p>}
            <p data-id="element-14336">
              {address.city}, {address.state} {address.postcode}
            </p>
            <p data-id="element-14337">{getCountryName(address.country)}</p>
          </div>
          <div className="flex justify-end space-x-2 mt-4" data-id="element-14338">
            <button type="button" onClick={() => onEdit(address)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14339">
              <EditIcon className="h-4 w-4" data-id="element-14340" />
            </button>
            <button type="button" onClick={() => onDelete(address.id)} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-14341">
              <TrashIcon className="h-4 w-4" data-id="element-14342" />
            </button>
          </div>
        </div>)}
      {addresses.length === 0 && <div className="col-span-full text-center py-4 text-sm text-gray-500" data-id="element-14343">
          No addresses found. Click "Add Address" to create one.
        </div>}
    </div>;
}